import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-snackbar',
  templateUrl: './loading-snackbar.component.html',
  styleUrls: ['./loading-snackbar.component.scss']
})
export class LoadingSnackbarComponent {
}
